import ReactComponent from '../../../assets/icons/options.svg?react';
import type { FC } from 'react';
import { BaseIcon, IconProps } from './BaseIcon';

export const OptionsIcon: FC<IconProps> = (props) => {
    return (
        <BaseIcon {...props}>
            <ReactComponent />
        </BaseIcon>
    );
};
